import { isInteger, isMoreThan, isRequiredText, strMax } from '../../utils';
export default {
    catchphrase: [strMax(85, 'キャッチフレーズは85文字以内で入力してください')],
    description: [strMax(2000, '自己紹介は2000文字以内で入力してください')],
    experience: [
        isMoreThan(0, '0以上の値を入力してください'),
        isInteger('整数で入力してください'),
    ],
    free: {
        assignable: [
            isRequiredText('対応可能時間を入力してください'),
            isMoreThan(0, '0以上の値を入力してください'),
            isInteger('整数で入力してください'),
        ],
    },
};
